export const small = '359px';

export const medium = '639px';

export const large = '1023px';
